import { connect } from "react-redux";
import Staff from "./staff";
import { getStaffById } from "../utils";

const mapStateToProps = (state) => ({
	person: getStaffById(state),
	profile: state.profile,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Staff);
